export default __webpack_public_path__ + "static/media/duster-gallery-10.cce33b95.jpg";